
    // JQUERY.MAGNIFIC-POPUP
    if ($.fn.magnificPopup) {
        // image
        $('.image-popup').magnificPopup({type:'image'});
        $('.image-group-popup').each(function() {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        });
        // iframe
        $('.iframe-popup').magnificPopup({type:'iframe'});
		$('.iframe-group-popup').each(function() {
			$(this).magnificPopup({
				delegate: 'a',
				type: 'iframe',
				gallery: {
					enabled: true
				}
			});
		});

		$('.zoom-gallery').each(function() {

			const body = document.querySelector('body');

			const initMagnificGallery = () => {
				$(this).magnificPopup({
					delegate: '.product-card:not(.--hidden) a',
					type: 'image',
					closeOnContentClick: false,
					closeBtnInside: false,
					overflowY: 'scroll',
					mainClass: 'mfp-img-mobile',
					image: {
						verticalFit: true,
					},
					gallery: {
						enabled: true
					},
					// zoom: {
					// 	enabled: true,
					// 	duration: 300,
					// 	opener: function(element) {
					// 		return element.find('img');
					// 	}
					// },
					fixedContentPos: false,
					callbacks: {
						open: function() {
							jQuery('body').addClass('noscroll');
							body.setAttribute('data-lenis-prevent', "");
							
							if (lenis) {
								lenis.stop();
							}
							
						},
						close: function() {
							jQuery('body').removeClass('noscroll');
							body.removeAttribute('data-lenis-prevent');
							
							if (lenis) {
								lenis.start();
							}
						}
					}
				});
			}
			initMagnificGallery();

			$("#filter-type input").on("change", function() {
				initMagnificGallery();
			});
		});

    }
